import { render } from "./index.vue?vue&type=template&id=c2751bb6&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=c2751bb6&lang=scss&scoped=true"

import exportComponent from "/Users/wangzicheng/Documents/kaola/projectWork/kaola/project-helpCenter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2751bb6"]])

export default __exports__